// The Stimulus-bundle copy of THE link rule — Crm::Workflows::ContentWording.link?
// on the server, smsHasLink in app/frontend/react/crm/smsLink.ts for React
// (separate build pipelines, no cross-bundle imports). Used by the Calendar's
// Meeting Details nudge (#17956). smsLinkCases.json is the one corpus all three
// are tested against (test/javascript/lib/sms_link.test.js runs it here), so a
// pattern that drifts reds a spec.

// A scheme, a www. address, or a merge field that becomes a link.
const LINK_PATTERN = /https?:\/\/|(?<![\w@.-])www\.[a-z0-9-]+\.|\{\{\s*[\w.]*(?:link|url)[\w.]*\s*\}\}/i

// A bare domain. The labels spell both cases; the TLD list stays lowercase-only
// (Ruby writes the TLD case-sensitive inside a case-insensitive pattern).
const BARE_DOMAIN_TLDS = ["com", "net", "org", "co", "io", "us", "info", "biz", "me", "ly", "gl", "gd", "cc", "xyz", "ai", "tv"]
const BARE_DOMAIN_PATTERN = new RegExp(
  "(?<![\\w@./-])(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+" +
  `(?:${BARE_DOMAIN_TLDS.join("|")})` +
  "(?![\\w@-]|\\.[a-zA-Z0-9])",
)

// True when the text carries a link the carriers filter.
export function smsHasLink(text) {
  const value = text ?? ""
  return LINK_PATTERN.test(value) || BARE_DOMAIN_PATTERN.test(value)
}
